const SELECTOR = "[data-scrollspy]"
const component = document.querySelector(SELECTOR)

const onIntersection =
  (link: Element) =>
  (entries: IntersectionObserverEntry[]): void => {
    if (!link) return
    const linkParent = link.parentNode as Element
    if (!linkParent) return

    entries.forEach(({ isIntersecting }) => {
      if (isIntersecting) {
        linkParent.classList.add("active")
        const closest = link.closest(SELECTOR)
        if (closest) closest.scrollLeft += link.getBoundingClientRect().left
      } else {
        linkParent.classList.remove("active")
      }
    })
  }

const observeTarget = (link: Element): void => {
  const href = link.getAttribute("href")
  if (!href) return
  const target = document.querySelector(href)
  if (!target) return

  const stickyNavObserver = new window.IntersectionObserver(onIntersection(link), {
    root: null,
    rootMargin: "-34% 0px -66% 0px",
    threshold: 0
  })
  stickyNavObserver.observe(target)
}

if (component) {
  for (const target of component.querySelectorAll("a")) {
    observeTarget(target)
  }
}
